export default __webpack_public_path__ + "static/media/20.2291c320.jpeg";